const modal = document.getElementById('joii-quick-add-modal');
const modalContent = document.getElementById('joii-quick-add-content');
const closeBtn = modal.querySelector('.close');
var product = null;

document.addEventListener("DOMContentLoaded", () => {
  console.log('%cJOII QUICK ADD', 'color: green; font-weight: bold;');

  document.addEventListener('click', handleDocumentClick);

  closeBtn.addEventListener('click', closeQuickAdd);

  modal.addEventListener('click', (e) => {
    if (e.target !== modal && !e.target.classList.contains(".joii-quick-add")) return;
    e.preventDefault();
    e.stopPropagation();
    closeQuickAdd();
    var thisQuickAdd = document.querySelector(".joii-quick-add.active");
    if (thisQuickAdd !== null && !modal.classList.contains("hidden")) {
      thisQuickAdd.classList.remove("active");
      thisQuickAdd.classList.remove("finished");
    }
  });
});

function handleDocumentClick(e) {

  // Quick add trigger
  const quickAdd = e.target.closest('.joii-quick-add');
  if (quickAdd) {
    e.stopPropagation();

    const handle = quickAdd.dataset.productHandle;
    openQuickAdd(handle,quickAdd);
    return;
  }

  // Quantity buttons
  const qtyBtn = e.target.closest('.qa-quantity-button');
  if (qtyBtn) {
    e.preventDefault();

    qaHandleQuantityButton(qtyBtn);
    return;
  }
}


function qaHandleQuantityButton(qtyBtn) {
  const qtyWrapper = qtyBtn.closest(".joii-qa-qty");
  const qtyInput = qtyWrapper.querySelector("input");
  const qtyIncrement = parseInt(qtyInput.getAttribute("step"), 10);
  const currentQty = parseInt(qtyInput.value, 10) || 0;
  //console.log(currentQty);
  if (qtyBtn.title == "Increase") {
    qtyInput.value = currentQty + qtyIncrement;
  }
  if (qtyBtn.title == "Decrease") {
    qtyInput.value = currentQty - qtyIncrement;
  }
  //console.log(qtyInput);
  return true;
}



function closeQuickAdd() {
  modal.classList.add("hidden");
  modalContent.innerHTML = '';
  var thisQuickAdd = document.querySelector(".joii-quick-add.active");
  if (thisQuickAdd !== null) {
    thisQuickAdd.classList.remove("active");
    thisQuickAdd.classList.add("finished");
  }
}


async function openQuickAdd(handle,quickAdd) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product fetch failed');

    product = await res.json();

    var has_plans = true;
    if (!product.selling_plan_groups || product.selling_plan_groups.length == 0) has_plans = false;

    console.log(product.variants.length);
    console.log(has_plans);

    console.log(product);
    if (product.variants.length == 1 && product.variants[0].available && !has_plans) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: product.variants[0].id,
          quantity: 1
        })
      });
      quickAdd.classList.add("finished");
      quickAddUpdateCartNumber();
    } else {
      renderQuickAdd(product);
      modal.classList.remove("hidden");
    }

    quickAdd.classList.add("active");

  } catch (err) {
    console.error(err);
  }
}


function renderQuickAdd(product) {
  const firstAvailableVariant =
    product.variants.find(v => v.available) || product.variants[0];

  modalContent.innerHTML = `
    <div class="joii-quick-add-inner">
      <a class="joii-qa-images" href="${product.url}">
        <img
          id="joii-qa-image"
          src="${product.images[0]}&width=400"
          alt="${product.title}"
          loading="eager"
        />
      </a>

      <div class="joii-qa-info">
        <div style="display: flex; flex-direction: column;">
          <h2 class="h2 product-heading" style="cursor: pointer;"><a style="color: black;" href="${product.url}">${product.title}</a></h2>
          <div class="product-price">
            <span class="price-item actual-price h3" id="joii-qa-price">${formatMoney(firstAvailableVariant.price)}</span>
          </div>
        </div>

        ${renderOptions(product)}

        ${renderSellingPlans(product)}

        <div class="joii-add-wrapper">
          <div class="product-quantity-wrapper" style="border: 2px solid #207EA7;">
            <div class="product-quantity-inner joii-qa-qty" data-quantity-wrapper="">
              <button type="button" class="qa-quantity-button no-js-hidden" data-quantity-decrement="" title="Decrease">
                <span class="hidden">Decrease</span>
                <svg x="0px" y="0px" width="10px" height="10px" viewBox="0 0 14 14">
                  <rect x="6" transform="matrix(6.123234e-17 -1 1 6.123234e-17 0 14)" width="2.1" height="14"></rect>
                </svg>
              </button>
              <input type="number" id="joii-qa-qty" value="1" min="1" class="quantity-input product-quantity" name="quantity" step="1" data-quantity-input="" placeholder="1">
              <button type="button" class="qa-quantity-button no-js-hidden" data-quantity-increment="" title="Increase">
                <span class="hidden">Increase</span>
                <svg x="0px" y="0px" width="10px" height="10px" viewBox="0 0 14 14">
                  <polygon points="14,6 8,6 8,0 6,0 6,6 0,6 0,8 6,8 6,14 8,14 8,8 14,8 "></polygon>
                </svg>
              </button>
            </div>
          </div>
          <button id="joii-qa-add" style="background: #207EA7; border: 1px solid #207EA7;" data-variant-id="${firstAvailableVariant.id}" class="hideAddfalse medium-btn button"><span>Add to basket</span></button>
          <div class="hideAddfalse medium-btn button trigger_joii_add_cart_popup" style="display: none; line-height: unset;"><span>Add to basket</span></div>
          <div style="display: none !important;" class="wishlist-engine joii-wishlist-btn-prod-page" data-product_id="" data-variant_id="" data-full_button="false" data-css="true"></div>
          
        </div>
      </div>
    </div>
  `;

  const qaSeeMore = modal.querySelector(".joii-quick-add-see-more");
  qaSeeMore.setAttribute("href",`${product.url}`);

  bindVariantEvents(product);
  bindAddToCart();
}




// function renderOptions(product) {
//   if (product.options.length === 1 && product.variants.length === 1) {
//     return '';
//   }

//   return product.options.map((option, index) => {
//     const variantOptions = [...new Set(product.variants.map(v => v.options[index]))];

//     return `
//       <div class="joii-qa-option" data-option-index="${index}">
//         <p style="margin-bottom: 10px;">${option.name}:</p>
//         <ul class="joii-qa-option-values product-selector-option-list">
//           ${variantOptions.map(variant => `
//             <li class="variant-option" type="button" data-value="${variant}">
//               <div class="option">${variant}</div>
//             </li>
//           `).join('')}
//         </ul>
//       </div>
//     `;
//   }).join('');
// }

function renderOptions(product) {
  if (product.options.length === 1 && product.variants.length === 1) {
    return '';
  }

  return product.options.map((option, index) => {
    const variantOptions = [...new Set(product.variants.map(v => v.options[index]))];

    return `
      <div class="joii-qa-option" data-option-index="${index}">
        <label style="margin-bottom: 6px; display: block;">${option.name}</label>
        <select class="joii-qa-option-select">
          ${variantOptions.map(value => `
            <option value="${value}">${value}</option>
          `).join('')}
        </select>
      </div>
    `;
  }).join('');
}



function renderSellingPlans(product) {
  if (
    !product ||
    !product.selling_plan_groups ||
    product.selling_plan_groups.length === 0
  ) {return '';}

  return `
    <div class="selling_plan_app_container joii-subscriptions-container" style="display: block !important;">
      <style>
          .product-price-block  {display: none !important;}
          .joii-sub-ppw {/*display: none;*/}
          .selling_plan_theme_integration--hidden {display: none;}
      </style>

      ${product.variants.map(variant => `
      <section id="singleRepeatToggle_${variant.id}" data-variant-id="${variant.id}" class="single-repeat-toggle-cont selling_plan_theme_integration section-in-view selling_plan_theme_integration--hidden" style="">
        <div class="joii_toggle_subscription_wrapper">

          <div class="joii_toggle_subscription joii_toggle_sub_one" data-variant-id="${variant.id}" data-radio-type="one_time_purchase">
            <div class="joii-plan-row">
            <label> Single Purchase </label>
            <div class="joii-sub-prices">
              <span class="joii-sub-price">${formatMoney(variant.price)}</span>
            </div>
                ${variant.weight > 0 ? `<span class="joii-sub-ppw">${formatMoney((variant.price / variant.weight) * 1000)}/kg</span>` : ``}
            </div>
          </div>

          <div class="joii_toggle_subscription" data-variant-id="${variant.id}" data-radio-type="selling_plan">
            <div class="joii-plan-row">
              <label> Repeat &amp; Save </label>
                <div class="joii-sub-prices">
                  <span class="joii-sub-price">${formatMoney(variant.selling_plan_allocations[0].price)}</span>
                </div>
                ${variant.weight > 0 ? `<span class="joii-sub-ppw">${formatMoney((variant.selling_plan_allocations[0].price / variant.weight) * 1000)}/kg</span>` : ``}
            </div>
          </div>
        </div>
      </section>
        `).join('')}
    </div>

    ${product.variants.map(variant => `
    <div id="sellingPlanDropdownContainer_${variant.id}" class="selling-plan-dropdown-container" data-variant-id="${variant.id}" style="display: none;">
      <label class="joii-prod-choose-plan-label" for="sellingPlan_${variant.id}">Choose your frequency:</label>
      <div class="joii-repeats-box">
        <button type="button" class="joii-selling-plan-toggle-dropdown-btn" variant-id="${variant.id}">
          <div class="joii-chosen-plan-container">
            ${product.selling_plan_groups.map(plan_group => `
              ${variant.selling_plan_allocations[0].selling_plan_group_id == plan_group.id ? `
                ${plan_group.selling_plans.map(plan => `
                  ${variant.selling_plan_allocations[0].selling_plan_id == plan.id ? `
                    <span class="joii-selling-plan-label">${plan.name}</span>
                    <span class="joii-selling-plan-discount" joii-disc-data="" style="display: none; font-size: 12px;">Save ${plan.price_adjustments[0].value_type == "percentage" ? `${plan.price_adjustments[0].value}%` : `${formatMoney(plan.price_adjustments[0].value)}`}</span>
                  `:``}
                `).join('')}
              `:``}
            `).join('')}
          </div>
        </button>
        <div id="sellingPlanDropdown_${variant.id}" class="joii-selling-plan-options joii-sub-popup" data-plan-id="4358766817" name="selling_plan_${variant.id}" style="display: none;">
          ${variant.selling_plan_allocations.map(allocation => `
            ${product.selling_plan_groups.map(plan_group => `
              ${plan_group.selling_plans.map(plan => `
                ${allocation.selling_plan_id == plan.id ? `
                  <div class="joii-selling-plan-option-box" group-name="${plan_group.name}" data-variant-id="${variant.id}" data-plan-id="${plan.id}" data_plan_name="${plan.name}" data-price="${formatMoney(allocation.price)}" data-price-adj="" data_plan_discount="">
                    <span class="joii-sell-plan-name">${plan.name}</span>
                    <span class="joii-sell-plan-discount" style="display: none; font-size: 12px;">${plan.price_adjustments[0].value_type == "percentage" ? `${plan.price_adjustments[0].value}%` : `${formatMoney(plan.price_adjustments[0].value)}`}</span>
                  </div>
                `:``}
              `).join('')}
            `).join('')}
          `).join('')}
        </div>
      </div>

            
      <div class="joii-sell-plan-descriptions">
        ${variant.selling_plan_allocations.map(allocation => `
          ${product.selling_plan_groups.map(plan_group => `
            ${plan_group.selling_plans.map(plan => `
              ${allocation.selling_plan_group_id == plan.id ? `
                <div class="joii-selling-plan-option-description" group-name="${plan_group.name}" data-variant-id="${variant.id}" data-plan-id="${plan.id}" data_plan_name="${plan.name}" data-price="${formatMoney(allocation.price)}" data-price-adj="" data_plan_discount="">
                  <p>${plan.description}</p>
                </div>
              `:``}
            `).join('')}
          `).join('')}
        `).join('')}
      </div>

    </div>
    `).join('')}
  `;
}





function bindVariantEvents(product) {
  const optionWrappers = modalContent.querySelectorAll('.joii-qa-option');
  const planContainers = modalContent.querySelectorAll('.selling-plan-dropdown-container');
  const togglePlanDropdowns = modalContent.querySelectorAll(".joii-selling-plan-toggle-dropdown-btn");
  const planDropdowns = modalContent.querySelectorAll('.joii-selling-plan-options');
  const planBtns = modalContent.querySelectorAll(".joii-selling-plan-option-box");
  const repeatToggles = modalContent.querySelectorAll(".single-repeat-toggle-cont");
  const repeatToggleBtns = modalContent.querySelectorAll(".joii_toggle_subscription");


  const selects = modalContent.querySelectorAll('.joii-qa-option-select');

  selects.forEach(select => {
    select.addEventListener('change', () => {
      const selectedOptions = getSelectedOptions();
      if (selectedOptions.includes(null)) return;

      const variant = findMatchingVariant(product, selectedOptions);
      if (!variant) return;

      modalContent.setAttribute("variant-id", variant.id);

      repeatToggles.forEach(rToggle => {
        rToggle.classList.toggle(
          'active',
          rToggle.id === `singleRepeatToggle_${variant.id}`
        );
      });

      updateSelectedVariant(product);
    });
  });


  optionWrappers.forEach(wrapper => {
    wrapper.addEventListener('click', (e) => {
      const btn = e.target.closest('.option');
      if (!btn) return;

      // UI active state
      wrapper.querySelectorAll('.option').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');


      var selectedOptions = getSelectedOptions();
      console.log(selectedOptions);
      if (selectedOptions.includes(null)) return;
      var variant = findMatchingVariant(product, selectedOptions);
      console.log(variant);
      modalContent.setAttribute("variant-id",variant.id);
      //const variant_id = btn.getAttribute("variant-id");

      repeatToggles.forEach(rToggle => {
        if (rToggle.id == `singleRepeatToggle_${variant.id}`) {
          rToggle.classList.add('active');
        } else {
          rToggle.classList.remove('active');
        }
      });

      // planOptions.forEach(planOption => {
      //   if (planOption.id == `sellingPlanDropdown_${variant.id}"`) {
      //     planOption.classList.add('active');
      //   } else {
      //     planOption.classList.remove('active');
      //   }
      // });

      updateSelectedVariant(product);
    });
  });

  // Auto-select first value of each option
  optionWrappers.forEach(wrapper => {
    const firstBtn = wrapper.querySelector('.option');
    if (firstBtn) firstBtn.classList.add('active');
  });
  var selectedOptions = getSelectedOptions();
  console.log(selectedOptions);
  if (selectedOptions.includes(null)) return;
  var variant = findMatchingVariant(product, selectedOptions);
  if (!variant) {
    variant = product.variants[0];
  }
  console.log(variant);
  modalContent.setAttribute("variant-id",variant.id);


  if (repeatToggles.length > 0) {
    repeatToggles[0].classList.add("active");
    var toggleSingles = modalContent.querySelectorAll(".joii_toggle_subscription.joii_toggle_sub_one");
    toggleSingles.forEach(toggleSingle => {
      toggleSingle.classList.add("active");
    });
  }
  
  repeatToggleBtns.forEach(repeatToggleBtn => {
    repeatToggleBtn.addEventListener('click', (e) => {
      var variant_id = modalContent.getAttribute("variant-id");
      if (repeatToggleBtn.classList.contains("joii_toggle_sub_one")) {
        repeatToggleBtns.forEach(rtb => {
          if (rtb.classList.contains("joii_toggle_sub_one")) {
            rtb.classList.add("active");
          } else {
            rtb.classList.remove("active");
          }
        });
        modalContent.classList.add("single");
        modalContent.classList.remove("sub");
        planContainers.forEach(planCont => {
          planCont.classList.remove('active');
        });
      } else {
        repeatToggleBtns.forEach(rtb => {
          if (rtb.classList.contains("joii_toggle_sub_one")) {
            rtb.classList.remove("active");
          } else {
            rtb.classList.add("active");
          }
        });
        modalContent.classList.add("sub");
        modalContent.classList.remove("single");
        planContainers.forEach(planCont => {
          if (planCont.id == `sellingPlanDropdownContainer_${variant_id}`) {
            planCont.classList.add('active');
          } else {
            planCont.classList.remove('active');
          }
        });
      }
    });
  });

  togglePlanDropdowns.forEach(togglePlanDropdown => {
    togglePlanDropdown.addEventListener('click', (e) => {
      const dropWrap = togglePlanDropdown.closest(".joii-repeats-box");
      if (dropWrap.classList.contains("active")) {
        dropWrap.classList.remove('active');
        planDropdowns.forEach(planDropdown => {
          planDropdown.classList.remove('active');
        });
      } else {
        dropWrap.classList.add('active');
        planDropdowns.forEach(planDropdown => {
          if (planDropdown.id == `sellingPlanDropdown_${togglePlanDropdown.getAttribute("variant-id")}`) {
            planDropdown.classList.add('active');
          } else {
            planDropdown.classList.remove('active');
          }
        });
      }
      console.log(dropWrap);
    });
  });


  planBtns.forEach(planBtn => {
    planBtn.addEventListener('click', (e) => {
      const dropWrap = planBtn.closest(".joii-repeats-box");
      dropWrap.classList.remove('active');
      const planLabel = dropWrap.querySelector(".joii-selling-plan-label")
      planLabel.textContent = planBtn.getAttribute("data_plan_name");
      planLabel.setAttribute("chosen-plan",planBtn.getAttribute("data-plan-id"));
      planDropdowns.forEach(planDropdown => {
        planDropdown.classList.remove('active');
      });
    });
  });

  updateSelectedVariant(product);
}

function qaSetSinglePrice(price,compare_at_price) {

}
function qaSetSubPrice(price,compare_at_price) {

}


// function getSelectedOptions() {
//   return Array.from(
//     modalContent.querySelectorAll('.joii-qa-option')
//   ).map(wrapper => {
//     const active = wrapper.querySelector('.option.active');
//     return active ? active.textContent.trim() : null;
//   });
// }

function getSelectedOptions() {
  return Array.from(
    modalContent.querySelectorAll('.joii-qa-option-select')
  ).map(select => select.value || null);
}


function findMatchingVariant(product, selectedOptions) {
  return product.variants.find(variant =>
    variant.options.every((opt, index) => opt === selectedOptions[index])
  );
}




// function updateSelectedVariant(product) {
//   const selectedOptions = Array.from(
//     modalContent.querySelectorAll('.joii-qa-option')
//   ).map(wrapper =>
//     wrapper.querySelector('button.active')?.dataset.value
//   );

//   const variant = product.variants.find(v =>
//     v.options.every((opt, i) => opt === selectedOptions[i])
//   );

//   if (!variant) {
//     console.log("no variant")
//     return;
//   }

//   document.getElementById('joii-qa-price').textContent = formatMoney(variant.price);

//   document.getElementById('joii-qa-add').dataset.variantId = variant.id;

//   // Optional: update image
//   if (variant.featured_image) {
//     document.getElementById('joii-qa-image').src =
//       variant.featured_image.src;
//   }
// }

function updateSelectedVariant(product) {
  const selectedOptions = Array.from(
    modalContent.querySelectorAll('.joii-qa-option-select')
  ).map(select => select.value);

  const variant = product.variants.find(v =>
    v.options.every((opt, i) => opt === selectedOptions[i])
  );

  if (!variant) {
    console.log("no variant", selectedOptions);
    return;
  }

  modalContent.setAttribute("variant-id", variant.id);

  document.getElementById('joii-qa-price').textContent =
    formatMoney(variant.price);

  document.getElementById('joii-qa-add').dataset.variantId = variant.id;

  if (variant.featured_image) {
    document.getElementById('joii-qa-image').src =
      variant.featured_image.src;
  }
}






function bindAddToCart() {
  const btn = document.getElementById('joii-qa-add');

  btn.addEventListener('click', async () => {
    const variantId = modalContent.getAttribute("variant-id");
    const qty = Number(document.getElementById('joii-qa-qty').value);

    const plan_id = modalContent
    .querySelector(".selling-plan-dropdown-container.active .joii-selling-plan-label")
    ?.getAttribute("chosen-plan");

    btn.disabled = true;
    btn.textContent = 'Adding…';

    if (modalContent.classList.contains("sub") && plan_id !== null) {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty,
          selling_plan: plan_id
        })
      });
    } else {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: variantId,
          quantity: qty
        })
      });
    }

    var thisQuickAdd = document.querySelector(".joii-quick-add.active");
    if (thisQuickAdd !== null) {
      thisQuickAdd.classList.remove("active");
      thisQuickAdd.classList.add("finished");
    }
    quickAddUpdateCartNumber();
    btn.textContent = 'Added!';
    //setTimeout(closeQuickAdd, 800);
    closeQuickAdd();
  });
}


async function quickAddUpdateCartNumber() {
  const cartNum = document.querySelector('.cart-count');
  if (!cartNum) return;

  try {
    const cartRes = await fetch('/cart.js');
    if (!cartRes.ok) throw new Error('Cart fetch failed');

    const cart = await cartRes.json();

    console.log('Cart item count:', cart.item_count);
    cartNum.textContent = cart.item_count;

  } catch (err) {
    console.error('Failed to update cart count', err);
  }

  try {
    var skelCartItem = addToCartSkeleton();
    addToCartItems(skelCartItem);
  } catch (err) {}
}



function formatMoney(cents) {
  const curSymbol = document.body.getAttribute("currency-symbol");
  return `${curSymbol}${(cents / 100).toFixed(2)}`;
}
